import { render } from "./IdleScreenComponent.vue?vue&type=template&id=4913ddec&scoped=true"
import script from "./IdleScreenComponent.vue?vue&type=script&lang=js"
export * from "./IdleScreenComponent.vue?vue&type=script&lang=js"

import "./IdleScreenComponent.vue?vue&type=style&index=0&id=4913ddec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4913ddec"]])

export default __exports__